import { useSelector } from 'react-redux';

export default function useResaShop() {
  const { selectedShop } = useSelector((s) => s.course);
  return selectedShop || null;
}
